
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 24 24","height":"22","width":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"#FFF"}},[_c('path',{attrs:{"d":"M11.018.75c5.67 0 10.268 4.597 10.268 10.268 0 5.67-4.597 10.268-10.268 10.268C5.348 21.286.75 16.689.75 11.018.75 5.348 5.347.75 11.018.75zm0 1.5a8.768 8.768 0 100 17.536 8.768 8.768 0 000-17.536z","vector-effect":"non-scaling-stroke","fill":"#bcb9ba"}}),_c('path',{attrs:{"d":"M17.155 4.134a.75.75 0 11.967 1.147c-.495.418-.932.84-1.31 1.265a.748.748 0 01-.032 1.498h-1.053A6.091 6.091 0 0015 10.075h.972a.75.75 0 110 1.5h-1.007c.086.767.334 1.52.747 2.261h1.4a.75.75 0 110 1.5h-.323c.384.434.828.864 1.333 1.29a.75.75 0 01-.967 1.147c-.93-.784-1.687-1.596-2.271-2.437h-.692a.75.75 0 01-.145-1.486 7.184 7.184 0 01-.59-2.274h-.405a.75.75 0 010-1.5l.432-.001c.087-.692.276-1.37.567-2.031h-.191a.75.75 0 110-1.5h1.043c.581-.83 1.333-1.634 2.252-2.41zM4.467 4.224a.75.75 0 011.057-.09c.872.736 1.593 1.497 2.161 2.282h1.209a.75.75 0 01.102 1.493l-.102.007H8.57a7.3 7.3 0 01.624 2.16h.828a.75.75 0 01.102 1.493l-.102.007h-.8a7.192 7.192 0 01-.528 2.131h.2a.75.75 0 01.102 1.494l-.102.007H7.883c-.595.886-1.383 1.741-2.36 2.565a.75.75 0 11-.967-1.147 12.477 12.477 0 001.445-1.419h-.028a.75.75 0 01-.101-1.492l.101-.007h1.064c.37-.7.595-1.41.677-2.132H7.1A.75.75 0 017 10.082l.101-.006h.578a6.15 6.15 0 00-.801-2.16h-.905a.75.75 0 01-.2-1.473l-.017-.02a12.997 12.997 0 00-1.2-1.142.75.75 0 01-.09-1.057z","vector-effect":"non-scaling-stroke","fill":"#bcb9ba"}})])])])
          )
        }
      }
    